import { Routes, Route, Outlet, Navigate } from "react-router-dom";
import StartNewImport from "src/components/importedListings/StartNewImport";
import PreviousImports from "src/components/importedListings/PreviousImports";
import SearchImportedListings from "src/components/importedListings/SearchImportedListings";
import ProtectedFeaturePage from "src/components/common/ProtectedFeaturePage";

const ImportedListingsPage = () => {
  return (
    <>
      <Routes>
        <Route 
          path="search" 
          element={
            <ProtectedFeaturePage featureKey="customupload" productName="Data Genie">
              <SearchImportedListings />
            </ProtectedFeaturePage>
          } 
        />
        <Route 
          path="start" 
          element={
            <ProtectedFeaturePage featureKey="customupload" productName="Data Genie">
              <StartNewImport />
            </ProtectedFeaturePage>
          } 
        />
        <Route 
          path="previous" 
          element={
            <ProtectedFeaturePage featureKey="customupload" productName="Data Genie">
              <PreviousImports />
            </ProtectedFeaturePage>
          } 
        />
        <Route index element={<Navigate to="search" />} />
      </Routes>
      <Outlet />
    </>
  );
};

export default ImportedListingsPage;
